import { validateNexxusUpdateManifest } from './NexxusUpdatePackage';
import type { NexxusUpdatePackageManifest } from './NexxusUpdateManifest';

/** Mise à jour hors ligne depuis un fichier paquet local. */
export class UsbUpdateService {
  async loadManifestFromFile(file: File): Promise<NexxusUpdatePackageManifest | null> {
    try {
      const text = await file.text();
      const json = JSON.parse(text) as unknown;
      const validation = validateNexxusUpdateManifest(json);
      if (!validation.valid) return null;
      return json as NexxusUpdatePackageManifest;
    } catch {
      return null;
    }
  }

  /**
   * Charge un manifeste signé (contrat C-D : `manifest_signature` + `platforms`).
   * Aucune vérification cryptographique ici : elle est faite par le processus principal.
   */
  async loadSignedManifestFromFile(file: File): Promise<Record<string, unknown> | null> {
    try {
      const json = JSON.parse(await file.text()) as Record<string, unknown>;
      if (
        json &&
        typeof json === 'object' &&
        typeof json.manifest_signature === 'string' &&
        typeof json.platforms === 'object' &&
        json.platforms !== null
      ) {
        return json;
      }
      return null;
    } catch {
      return null;
    }
  }
}
